import { TypographyProps } from '@mui/material/Typography';
import { ReactNode, FC } from 'react';

import Field from './Field';

type Props = {
  readonly label: string;
  readonly children: ReactNode;
  readonly visible: boolean;
  readonly classes?: TypographyProps['classes'];
  readonly testId?: string;
};

const AssetInfoField: FC<Props> = ({
  label,
  children,
  visible,
  classes = undefined,
  testId = undefined,
}: Props) => (
  <Field
    label={label}
    visible={visible}
    variant="caption"
    labelAndDisplayOnSameLine={false}
    classes={classes}
    testId={testId}
  >
    {children}
  </Field>
);

export default AssetInfoField;
